import type { ElementType, ReactNode } from 'react'

interface ContainerProps {
  children: ReactNode
  /** Rendered element/component, e.g. 'nav' | 'main' | 'section'. Defaults to 'div'. */
  as?: ElementType
  /** Extra classes appended after the base padding (layout, spacing, flex, etc.). */
  className?: string
  /** Override the default horizontal padding (e.g. for pages that need all-side padding). */
  padding?: string
}

/** Shared page-content padding, matching Header/Footer's full-width layout. */
export default function Container({
  children,
  as: Component = 'div',
  className = '',
  padding = 'px-4 md:px-8',
}: ContainerProps) {
  return (
    <Component className={[padding, className].filter(Boolean).join(' ')}>
      {children}
    </Component>
  )
}
